import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const withAuthentication = (Component) => {
  const WithAuthentication = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
      //console.log("withAuthentication: Mounted");
      return () => {
        //console.log("withAuthentication: Unmounted");
      };
    }, []);

    // Render the component without any Firebase auth logic for now
    return <Component {...props} />;
  };

  return WithAuthentication;
};

export default withAuthentication;
